import { render, staticRenderFns } from "./CompanyImage.vue?vue&type=template&id=2bfc812f&scoped=true&"
import script from "./CompanyImage.vue?vue&type=script&lang=js&"
export * from "./CompanyImage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyImage.vue?vue&type=style&index=0&id=2bfc812f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc812f",
  null
  
)

export default component.exports